//
// Limits mixin
// ------------

define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var depositLimitsConfig = require('modules/deposit-limits-config/deposit.limits.config.instance');
    var betLimitsConfig = require('modules/bet-limits-config/bet.limits.config.instance');
    var lossLimitsConfig = require('modules/loss-limits-config/loss.limits.config.instance');

    module.exports = {

        handleUpdateLimitsCurrency: function(event) {
            const value = event.target.value.trim();

            this.updateLimitsCurrency(value);
        },

        updateLimitsCurrency: function(currencyCode) {
            var $limitList = [
                this.$('.fn-day-deposit-limit, .fn-week-deposit-limit, .fn-month-deposit-limit'),
                this.$('.fn-session-bet-limit, .fn-day-bet-limit, .fn-week-bet-limit, .fn-month-bet-limit'),
                this.$('.fn-session-loss-limit, .fn-day-loss-limit, .fn-week-loss-limit, .fn-month-loss-limit')
            ];

            var flattened = _.chain($limitList)
                .map(_.toArray)
                .flatten()
                .value();

            if (!flattened.length) {
                return;
            }

            currencyCode = currencyCode || this.$('.fn-currency').val();

            if ($limitList[2].length) {
                lossLimitsConfig.fetchLossLimits(currencyCode).done(function(response) {
                    this.updateLimits($limitList[2], response.config.predefinedLimits, response.config.defaultLimits);
                }.bind(this));
            }

            if ($limitList[1].length) {
                betLimitsConfig.fetchBetLimits(currencyCode).done(function(response) {
                    this.updateLimits($limitList[1], response.config.predefinedLimits, response.config.defaultLimits);
                }.bind(this));
            }

            if ($limitList[0].length) {
                if (depositLimitsConfig.lastFetchedLimits) {
                    var limit = depositLimitsConfig.getLimitByCurrency(currencyCode);

                    this.updateLimits($limitList[0], limit.allowedLimits, limit);
                }
            }

            this.updateCurrencySign(flattened, currencyCode);
        },

        updateLimits: function(inputs, limits, defaultLimits) {
            const getType = el => $('[name]', el).attr('name') || $(el).attr('name');

            inputs.forEach(function(el) {
                var type = getType(el);
                var defaultValue = this.getDefaultValue(defaultLimits, type);

                $(el).trigger(new $.Event('change:options', {
                    payload: {
                        dataList: limits,
                        value: defaultValue
                    }
                }));
            }.bind(this));
        },

        updateCurrencySign: function(inputs, code) {
            inputs.forEach(function(el) {
                var currency = window.Playtech.API.formatter.formatCurrency('', { currencyCode: code });
                var len = currency.length;
                var element = el.closest('.field__control[data-currency-symbol]')
                    || $(el).find('.fn-editable-control')[0];
                len = !len || len < 1
                    ? 1
                    : len > 3
                        ? 3
                        : len;

                if (element) {
                    element.dataset.currencySymbol = currency;
                    element.dataset.currencySymbolLength = len;
                }
            });
        },

        getDefaultValue: function(limit, type) {
            var betMap = {
                sessionbetlimit: 'sessionDefaultLimit',
                daybetlimit: 'dailyDefaultLimit',
                weekbetlimit: 'weeklyDefaultLimit',
                monthbetlimit: 'monthlyDefaultLimit'
            };

            var lossMap = {
                sessionlosslimit: 'sessionDefaultLimit',
                daylosslimit: 'dailyDefaultLimit',
                weeklosslimit: 'weeklyDefaultLimit',
                monthlosslimit: 'monthlyDefaultLimit'
            };

            var depositMap = {
                daydepositlimit: 'dailyDefaultLimit',
                weekdepositlimit: 'weeklyDefaultLimit',
                monthdepositlimit: 'monthlyDefaultLimit'
            };

            var map;

            if (type.match('betlimit')) {
                map = betMap;
            } else if (type.match('losslimit')) {
                map = lossMap;
            } else {
                map = depositMap;
            }

            return limit[map[type]];
        }

    };
});
